import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URLS } from '../apiConfig';
import PersonasForm from './Personas/PersonasForm';
import PersonasList from './Personas/PersonasList';
import MovimientoForm from './Activos/MovimientoForm';
import ReportesView from './Activos/ReportesView';
import ActivosManagement from './Activos/ActivosManagement'; 
import DestinosManagement from './Destinos/DestinosManagement'; 
import ProductManagement from './Activos/ProductManagement'; 
import AssetHistoryReport from './Activos/AssetHistoryReport'; 
import ProductMovements from './Activos/ProductMovements'; 

function Dashboard() {
  const userRol = localStorage.getItem('userRol') || 'retiro_mercaderia';
  const esAdmin = userRol === 'administrador' || userRol === 'usuario_stock';

  const [vistaActual, setVistaActual] = useState('personas');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const mainContentRef = useRef(null);

  const cambiarVista = (nuevaVista) => {
    setCargando(true);
    setVistaActual(nuevaVista);

    setTimeout(() => {
      setCargando(false);
      if (window.innerWidth <= 768) {
        mainContentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 400); 
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRol');
    navigate('/');
  };
  
  const [dataRefreshKey, setDataRefreshKey] = useState(0);
  const handleDataRefresh = () => setDataRefreshKey(prev => prev + 1);

  return (
    <div className="dashboard-layout">
      <div className="sidebar">
        <h1 className="sidebar-title">SISTEMA SCAGLIA</h1>
        <ul className="sidebar-menu">
          <li>
            <button onClick={() => cambiarVista('personas')} className={`btn btn-secondary ${vistaActual === 'personas' ? 'active' : ''}`}>
              Gestión de Personas
            </button>
          </li>

          {esAdmin && (
            <>
              <li>
                <button onClick={() => cambiarVista('destinos')} className={`btn btn-secondary ${vistaActual === 'destinos' ? 'active' : ''}`}>
                  Gestión de Destinos
                </button>
              </li>
              <li>
                <button onClick={() => cambiarVista('activos')} className={`btn btn-secondary ${vistaActual === 'activos' ? 'active' : ''}`}>
                  Gestión de Equipos
                </button>
              </li>
              <li>
                <button onClick={() => cambiarVista('maquinas')} className={`btn btn-secondary ${vistaActual === 'maquinas' ? 'active' : ''}`}>
                  Registro de Movimientos Maquinas
                </button>
              </li>
              <li>
                <button onClick={() => cambiarVista('reportes')} className={`btn btn-secondary ${vistaActual === 'reportes' ? 'active' : ''}`}>
                  Generar Reportes Activos
                </button>
              </li>
              <hr className="sidebar-divider my-2 opacity-20" />
              <li>
                <button onClick={() => cambiarVista('productos')} className={`btn btn-secondary ${vistaActual === 'productos' ? 'active' : ''}`}>
                  Gestión de Productos
                </button>
              </li>
              <li>
                <button
                  onClick={() => cambiarVista('movimientos-productos')}
                  className={`btn btn-secondary flex items-center gap-2 ${vistaActual === 'movimientos-productos' ? 'active' : ''}`}
                >
                  <i className="bi bi-arrow-left-right"></i>
                  Movimientos Stock
                </button>
              </li>
              <li>
                <button onClick={() => cambiarVista('reporte-productos')} className={`btn btn-secondary ${vistaActual === 'reporte-productos' ? 'active' : ''}`}>
                  Historial de Productos
                </button>
              </li>
            </>
          )}
        </ul>
        <button onClick={handleLogout} className="btn btn-primary sidebar-logout-btn">
          Cerrar Sesión
        </button>
      </div>

      <div className="main-content" ref={mainContentRef}>
        {cargando ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Cargando...</p>
          </div>
        ) : (
          <>
            {vistaActual === 'activos' && <ActivosManagement />} 
            {vistaActual === 'destinos' && <DestinosManagement />} 
            {vistaActual === 'maquinas' && <MovimientoForm onMovimientoRegistrado={handleDataRefresh} />} 
            {vistaActual === 'reportes' && <ReportesView key={dataRefreshKey} />}
            {vistaActual === 'productos' && <ProductManagement />}
            
            {/* 3. RENDERIZADO DE LOS COMPONENTES DE PRODUCTOS */}
            {vistaActual === 'movimientos-productos' && <ProductMovements />}
            {vistaActual === 'reporte-productos' && <AssetHistoryReport />}

            {vistaActual === 'personas' && (
              <>
                <PersonasForm />
                {esAdmin && (
                  <>
                    <hr className="my-5" />
                    <PersonasList />
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;